module.exports = __webpack_public_path__ + "img/help-on-menu.b14fd2da.jpeg";